import { SheetDefaults } from '../constants/sheetDefaults';

export const getHorizontalMax = (
  gridX: number,
  gridWidth: number,
  isRtl: boolean
) => (isRtl ? gridWidth : gridX);

export const getColumnRootX = (
  gridX: number,
  gridWidth: number,
  rowHeaderWidth: number,
  isRtl: boolean
) => (isRtl ? gridWidth - rowHeaderWidth : gridX);
